/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { H2 } from 'UIComponents/elements/headings';
import getPropertyValue from '../../../dataAccessHelpers/getPropertyValue';
import I18n from 'I18n';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { usageTracker } from '../../../utils/usageTracker';
import useDeletePayment from '../../../hooks/useDeletePayment';
import { getDisplayedValue } from 'customer-data-property-utils/PropertyValueDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DeleteModal = ({
  objectId,
  onClose,
  properties,
  associations,
  isSyncedPayment
}) => {
  const amount = I18n.formatCurrency(Number(getPropertyValue(properties, 'hs_initial_amount')), {
    currencyCode: getPropertyValue(properties, 'hs_currency_code')
  });
  const {
    definition,
    value
  } = properties.hs_processor_type;
  const processorTypeDisplayValue = getDisplayedValue(definition, value);
  const {
    deletePaymentMutation,
    deletePaymentButtonLoading
  } = useDeletePayment({
    associations,
    onClose
  });
  const handleDeleteConfirm = () => {
    usageTracker.track('paymentCRMSidebarUsage', {
      action: 'deleteModalSubmitClicked'
    });
    return deletePaymentMutation({
      variables: {
        objectId
      }
    });
  };
  const handleDeleteCancel = () => {
    usageTracker.track('paymentCRMSidebarInteraction', {
      action: 'deleteModalCancelClicked'
    });
    onClose();
  };
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "danger",
    "data-test-id": "delete-modal",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.delete.modal.header"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: handleDeleteCancel,
        disabled: deletePaymentButtonLoading
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: isSyncedPayment ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            className: "m-bottom-2",
            message: "cardPaymentHighlight.paymentHighlight.sidebarActions.delete.modal.syncedPayment.body",
            options: {
              externalSource: processorTypeDisplayValue
            }
          })
        }), /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              className: "m-bottom-2",
              message: "cardPaymentHighlight.paymentHighlight.sidebarActions.delete.modal.syncedPayment.warning"
            })
          })
        })]
      }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "cardPaymentHighlight.paymentHighlight.sidebarActions.delete.modal.body",
        options: {
          amount
        }
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UILoadingButton, {
        use: "danger",
        onClick: handleDeleteConfirm,
        loading: deletePaymentButtonLoading,
        "data-test-id": "delete-payment-confirm-btn",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.delete.modal.delete"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "tertiary-light",
        disabled: deletePaymentButtonLoading,
        onClick: handleDeleteCancel,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.delete.modal.cancelButtonText"
        })
      })]
    })]
  });
};
export default DeleteModal;